import { Navigation } from 'swiper/modules';
import Swiper from 'swiper';

export default function initPayment() {
  Alpine.data('payment', (billingAddressReady: boolean) => ({
    paymentMethod: '',
    gatewayId: '',
    feeMessage: '',
    billingAddressReady,
    init() {
      const swiperEl = this.$el.querySelector('.payment-method-swiper') as HTMLElement;
      if (swiperEl) {
        // eslint-disable-next-line no-new
        new Swiper(swiperEl, {
          modules: [Navigation],
          spaceBetween: 16,
          slidesPerView: 'auto',
          navigation: {
            nextEl: `#${(swiperEl.parentNode as HTMLElement).id} .address-swiper-button-next`,
            prevEl: `#${(swiperEl.parentNode as HTMLElement).id} .address-swiper-button-prev`,
            disabledClass: 'hidden',
          },
        });
      }

      this.$nextTick(() => {
        const target = this.$el.querySelector<HTMLInputElement>('input[type="radio"][name="paymentMethodSelected"]:checked')
          ?? this.$el.querySelector<HTMLInputElement>('input[type="radio"][value="ideal"]')
          ?? this.$el.querySelector<HTMLInputElement>('input[type="radio"][name="paymentMethodSelected"]')
          ?? this.$el.querySelector<HTMLInputElement>('input[type="radio"]');

        if (!target) return;

        target.checked = true;
        this.selectGateway(
          target.value,
          target.dataset.gatewayId ?? '',
          target.dataset.feeMessage ?? '',
        );
      });
    },
    buttonClasses() {
      return this.paymentMethod === ''
        || this.gatewayId === ''
        || !Alpine.store('shippingMethodReady')
        || Alpine.store('shippingMethodSaving')
        || this.isPaymentMethodSaving()
        ? 'opacity-50'
        : '';
    },
    isPaymentMethodSaving() {
      const paymentMethodWrapper = document.getElementById('payment-method');
      return paymentMethodWrapper?.classList.contains('htmx-request') ?? false;
    },
    syncSelectedPaymentFromDom() {
      const selectedInput = this.$el.querySelector<HTMLInputElement>('input[type="radio"][name="paymentMethodSelected"]:checked');
      if (!selectedInput) {
        return;
      }

      this.selectGateway(
        selectedInput.value,
        selectedInput.dataset.gatewayId ?? '',
        selectedInput.dataset.feeMessage ?? '',
      );
    },
    handlePaymentMethodChange(method: string, gateway: string, feeMessage = '') {
      this.selectGateway(method, gateway, feeMessage);
      const paymentMethodBlock = document.getElementById('payment-method') as HTMLElement;
      paymentMethodBlock?.scrollIntoView({ block: 'start' });
    },
    handleSubmit(event: Event) {
      this.syncSelectedPaymentFromDom();

      if (!billingAddressReady) {
        event.preventDefault();
        const billingAddressLink = document.getElementById('billing-address-link') as HTMLElement;
        if (billingAddressLink) {
          window.scrollTo(billingAddressLink.offsetLeft, billingAddressLink.offsetTop - 130);
          billingAddressLink.classList.add('text-price-sale!');
          setTimeout(() => billingAddressLink.classList.remove('text-price-sale!'), 7000);
        }
      } else if (this.isPaymentMethodSaving()) {
        event.preventDefault();
        const paymentMethodBlock = document.getElementById('payment-strip') as HTMLElement;
        paymentMethodBlock?.scrollIntoView({ block: 'center' });
      } else if (!Alpine.store('shippingMethodReady') || Alpine.store('shippingMethodSaving')) {
        event.preventDefault();
        const shippingMethodBlock = document.querySelector('.shipping-method.selected') as HTMLElement;
        if (shippingMethodBlock) {
          shippingMethodBlock.scrollIntoView({ block: 'center' });
          shippingMethodBlock.classList.add('border-price-sale!', 'has-error');
          setTimeout(() => shippingMethodBlock.classList.remove('border-price-sale!', 'has-error'), 7000);
        }
      } else if (this.paymentMethod === '' || this.gatewayId === '') {
        event.preventDefault();
        const paymentMethodBlock = document.getElementById('payment-strip') as HTMLElement;
        if (paymentMethodBlock) {
          paymentMethodBlock.scrollIntoView({ block: 'center' });
          paymentMethodBlock.classList.add('border-2!', 'border-price-sale!', 'py-3.5!');
          setTimeout(() => paymentMethodBlock.classList.remove('border-2!', 'border-price-sale!', 'py-3.5!'), 7000);
        }
      }
    },
    selectGateway(method: string, gateway: string, feeMessage = '') {
      this.paymentMethod = method;
      this.gatewayId = gateway;
      this.feeMessage = feeMessage;
      const paymentMethodBlock = document.getElementById('payment-strip') as HTMLElement;
      if (paymentMethodBlock) {
        paymentMethodBlock.classList.remove('border-2!', 'border-price-sale!', 'py-3.5!');
      }
    },
  }));
}
